import { render, staticRenderFns } from "./Depositlist.vue?vue&type=template&id=e0f8b4dc&scoped=true&"
import script from "./Depositlist.vue?vue&type=script&lang=js&"
export * from "./Depositlist.vue?vue&type=script&lang=js&"
import style0 from "./Depositlist.vue?vue&type=style&index=0&id=e0f8b4dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f8b4dc",
  null
  
)

export default component.exports